import React from "react";
import cn from "classnames";
import { Icon } from "@evidenceb/athena-common/design-system/Icon";
import { defineMessages, useIntl } from "react-intl";
import { Step } from "../utils";

import "./StepProgression.scss";

type Props = {
    step: Step;
};

const StepProgression = ({ step }: Props) => {
    const intl = useIntl();

    return (
        <div className="add-duo-modal__step-container">
            <StepTab
                label={intl.formatMessage(messages.addDuoModalChooseGroupTab)}
                state={getStepState(Step.ChooseGroup, step)}
            />
            <StepTab
                label={intl.formatMessage(messages.addDuoModalChooseDuoTab)}
                state={getStepState(Step.ChooseDuo, step)}
            />
            <StepTab
                label={intl.formatMessage(messages.addDuoModalDefineRolesTab)}
                state={getStepState(Step.DefineRoles, step)}
            />
        </div>
    );
};
export default StepProgression;

const getStepState = (stepState: Step, currentState: Step) => {
    if (currentState === stepState) return "active";
    if (currentState === Step.ChooseGroup) {
        return "incoming";
    } else if (currentState === Step.ChooseDuo) {
        if (stepState === Step.ChooseGroup) return "done";
        if (stepState === Step.DefineRoles) return "incoming";
    }
    return "done";
};

type StepTabProps = {
    state: "done" | "active" | "incoming";
    label: string;
};
const StepTab = ({ state, label }: StepTabProps) => {
    return (
        <div className={cn("add-duo-modal__step", `--${state}`)}>
            <div className="step__bar-indicator" />
            <div className="step__label">
                <Icon path={getIcon(state)} />
                {label}
            </div>
        </div>
    );
};
const getIcon = (state: StepTabProps["state"]) => {
    switch (state) {
        case "active":
            return "checkbox-selected";
        case "done":
            return "valid";
        case "incoming":
            return "checkbox-disabled";
        default: {
            const _: never = state;
            return "";
        }
    }
};

const messages = defineMessages({
    addDuoModalChooseGroupTab: {
        id: "duoMode-addDuoModal-chooseGroupTab",
        defaultMessage: "Choose the class",
    },
    addDuoModalChooseDuoTab: {
        id: "duoMode-addDuoModal-chooseDuoTab",
        defaultMessage: "Choose the duo",
    },
    addDuoModalDefineRolesTab: {
        id: "duoMode-addDuoModal-defineRolesTab",
        defaultMessage: "Defines the roles",
    },
});
